export function useLibraryStyle() {
  /** 使用 library-style 屬性 */
  const addLibraryStyle = () => {
    document.querySelector('html')?.setAttribute('library-style', '')
  }

  /** 移除 library-style 屬性 */
  const removeLibraryStyle = () => {
    document.querySelector('html')?.removeAttribute('library-style')
  }

  /** 使用 no-library-style 屬性 */
  const addNoLibraryStyle = () => {
    document.querySelector('html')?.setAttribute('no-library-style', '')
  }

  /** 移除 no-library-style 屬性 */
  const removeNoLibraryStyle = () => {
    document.querySelector('html')?.removeAttribute('no-library-style')
  }

  return {
    addLibraryStyle,
    addNoLibraryStyle,
    removeLibraryStyle,
    removeNoLibraryStyle
  }
}
